import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class ImportCommand extends AbstractConfDataCommand {
  sourceConfId?: number;
  sourceConfIdentity?: string;
  sourceConfRevision?: string;
  getSuggestionsProductId?: number;
  getSuggestionsKeywords?: string;
  getSuggestionsAutoComplete?: boolean = false;
}